<template>
  <div class="nr-message">
    <div class="nr-message-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NrMessage'
}
</script>

<style lang="scss">
@import '../../styles/tokens/tokens.scss';

.nr-message {
  background-color: $color-pink-80;
  &-body {
    border-color: $color-red-100;
    border-width: 0 0 0 $spacing-4;
    border-style: solid;
    padding: $spacing-16 $spacing-24;
    color: $color-red-100;
    border-radius: $spacing-4;
  }
}
</style>
